import * as React from 'react';

import {SubdomainSelect} from 'shells/subdomain-select/subdomain-select';
import type {Props as SubdomainSelectProps} from 'shells/subdomain-select/subdomain-select';

import type {Flow} from 'flow-to-typescript-codemod';

import {useGetSessionUser} from '../use-get-session-user';

type Props = Flow.Diff<
    SubdomainSelectProps,
    {
        canAccessSetup?: boolean;
    }
>;

export function SubdomainSelectWrapper(props: Props) {
    const {user} = useGetSessionUser();

    const canAccessSetup = user ? user.permissions.canAccessSetup : false;

    return <SubdomainSelect {...props} canAccessSetup={canAccessSetup} />;
}
